//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PopModal from './_pop_modal.vue'
const EMPLOYMENT_CERTIFICATION__LINK = 'https://cdn.vip-wifi.com/fcdocs/%E7%A8%B3%E5%AE%9A%E5%B0%B1%E4%B8%9A%E8%AF%81%E6%98%8E.doc'
const isIOS = wx.getSystemInfoSync().system.substring(0, 3).toLowerCase() === 'ios'
export default {
    components: {
        PopModal
    },
    methods: {
        download() {
            this.$refs.popModal.toggleModal()
        },
        preview (e) {
            const { img } = e.currentTarget.dataset
            wx.previewImage({
                current: img,
                urls: [img],
            })
        },
        goWeb() {
            const link = 'https://mp.weixin.qq.com/s/Y42XaRvHIX8Eb3yxWjz-Pw'
            const url = `/web_page?link=${encodeURIComponent(link)}&title=${process.env.APP_NAME}`
            wx.navigateTo({
                url
            })
        },
    }
}
